import Components from "../components";

class LinearSettings extends Components.Base {
  bind() {
    this.$teamKey = this.$el.find("#channel_team_key");
    this.$teamSelect = this.$el.find("#channel_team_id");
    this.$teamSelect.on("change", this.onTeamSelect.bind(this));
    this.populateTeams(this.$teamSelect.attr("value"));
  }

  onTeamSelect(evt) {
    this.populateTeams(evt.target.value);
  }

  addOption(el, value, text, selected) {
    el.append($("<option>", { value, text, selected }));
  }

  populateTeams(selectedTeamId) {
    this.resetSelect(this.$teamSelect);
    let selected;
    window.linear_config.forEach((team) => {
      const teamSelected = selectedTeamId === team.id;
      this.addOption(this.$teamSelect, team.id, team.name, teamSelected);
      if (teamSelected) selected = team;
    });
    if (selected) {
      this.$teamKey.attr("value", selected.key);
      this.populateLists(selected);
    } else {
      this.nextListsRequest();
      this.showListsPlaceholder("");
    }
  }

  // A load that finishes after Turbo tears the form down has nothing to fill.
  destroy() {
    this.nextListsRequest();
    super.destroy();
  }

  // Each team change supersedes any lists still loading for an earlier one.
  nextListsRequest() {
    this.listsRequest = (this.listsRequest || 0) + 1;
    return this.listsRequest;
  }

  // The page embeds only the saved team's lists; other teams' lists are
  // fetched the first time they're picked. Selects stay enabled with a blank
  // choice while loading or after a failure, so a save then clears the
  // previous team's ids instead of omitting the fields and keeping them.
  async populateLists(team) {
    const request = this.nextListsRequest();
    if (!team.labels) {
      this.showListsPlaceholder("Loading…");
      let body, failure;
      try {
        const response = await fetch(this.teamUrl(team.id), {
          headers: { Accept: "application/json" },
        });
        body = await response.json();
        if (!response.ok) failure = new Error(body.error || "");
      } catch (error) {
        failure = error;
      }
      // A slow response the user has since changed teams after; dropped
      // rather than cached, so it can't replace newer lists later.
      if (request !== this.listsRequest) return;
      if (failure) {
        const reason = failure.message || "";
        this.showListsPlaceholder(
          `Couldn't load from Linear. ${reason}`.trim(),
        );
        return;
      }
      Object.assign(team, body);
    }
    this.populateListsWith(team);
  }

  populateListsWith(team) {
    this.listSelects().forEach(([$el, key]) =>
      this.populateSelects($el, team[key]),
    );
    this.populateCheckBoxes(
      "label_ids",
      this.$el.find(".channel_label_ids"),
      team.labels,
    );
  }

  showListsPlaceholder(text) {
    this.listSelects().forEach(([$el]) => {
      $el.empty();
      this.addOption($el, "", text);
    });
    this.populateCheckBoxes(
      "label_ids",
      this.$el.find(".channel_label_ids"),
      [],
    );
  }

  listSelects() {
    return [
      [this.$el.find("#channel_linear_project_id"), "projects"],
      [this.$el.find("#channel_unresolved_state_id"), "states"],
      [this.$el.find("#channel_resolved_state_id"), "states"],
    ];
  }

  teamUrl(teamId) {
    const url = new URL($("#linear-config").data("teamUrl"), window.location);
    url.searchParams.set("team_id", teamId);
    return url;
  }

  resetSelect($el) {
    $el.empty();
    this.addOption($el, "", "");
  }

  populateSelects($el, coll) {
    this.resetSelect($el);
    const selectedId = $el.attr("value");
    coll.forEach((item) => {
      this.addOption($el, item.id, item.name, selectedId === item.id);
    });
  }

  populateCheckBoxes(name, $el, coll) {
    $el.find("span").remove();
    const checked = $el.prev().attr("value");
    coll.forEach((item) => {
      const wrapper = $('<span class="checkbox form-check">');
      const id = `channel_${name}_${item.id}`;
      $el.append(wrapper);
      wrapper.append(
        $("<input>", {
          id,
          class: "form-check-input check_boxes optional",
          type: "checkbox",
          name: `channel[${name}][]`,
          checked: checked !== undefined ? checked.includes(item.id) : false,
          value: item.id,
        }),
      );

      if (item.color !== undefined) {
        wrapper.append(
          $("<label>", {
            for: id,
            class: "form-checkbox-color-label",
            style: `background-color: ${item.color}`,
          }),
        );
      }

      wrapper.append(
        $("<label>", {
          class: "form-check-label collection_check_boxes",
          for: id,
        }).append(item.name),
      );
    });
  }
}

Components.collection.register({
  selector: "form[data-kind=linear]",
  klass: LinearSettings,
});
